import { useSyncExternalStore } from 'react';

/**
 * CORE-1741 — картинка из чата во весь экран в приложении. Открыть её в
 * системном браузере нельзя: файл закрытой сессии отдаётся только с
 * заголовками, поэтому он уже скачан в кеш, а показывает его
 * `ChatImageViewerHost`, смонтированный один раз в корне приложения.
 */
export interface ChatImageViewerRequest {
  uri: string;
  name: string | null;
  /** Окно закрыли — отпустить файл из кеша. */
  onClose?: () => void;
}

let request: ChatImageViewerRequest | null = null;
const listeners = new Set<() => void>();

function emit(next: ChatImageViewerRequest | null): void {
  request = next;
  listeners.forEach((l) => l());
}

export function openChatImageViewer(next: ChatImageViewerRequest): void {
  request?.onClose?.();
  emit(next);
}

export function closeChatImageViewer(): void {
  request?.onClose?.();
  emit(null);
}

const subscribe = (l: () => void) => {
  listeners.add(l);
  return () => { listeners.delete(l); };
};
const snapshot = () => request;

export function useChatImageViewerRequest(): ChatImageViewerRequest | null {
  return useSyncExternalStore(subscribe, snapshot, snapshot);
}
